// project imports
import NavCard from './NavCard';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import { useGetMenuMaster } from 'api/menu';
import { Box } from '@mui/material';
// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

   
return (
    <>
      <SimpleBar
        sx={{
          bgcolor: '#FFFFFF',
          color: '#333333',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          '& .simplebar-content': {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            bgcolor: '#FFFFFF',
            color: '#333333'
          }
        }}
      >
        <Navigation />
        {drawerOpen && (
          <Box sx={{ p: 2 }}>
            <NavCard />
          </Box>
        )}
      </SimpleBar>
    </>
  );
}
